module.exports = __webpack_public_path__ + "img/s03_bg-no-space.8280135c.png";